export const chatbot = {
   p1: `Configure seu Assistente Virtual`,
   p2: `Ative o serviço de chatbot para responder automaticamente às perguntas mais comuns dos seus hóspedes.`,
   p3: `Configure seu Assistente Virtual. Personalize as respostas do seu chatbot para oferecer informações rápidas e precisas aos seus hóspedes. Resolva automaticamente as dúvidas mais frequentes.`,
   p4: `Configurar`,
   p5: `Assistente Virtual ativado com sucesso`,
   p6: `Assistente Virtual desativado`,

   p7: `Configure as respostas do ChatBot`,
   p8: `Acomodação atribuída:`,
   p9: `Personalize as respostas automáticas do chatbot para atender com eficiência às perguntas mais frequentes dos seus hóspedes.`,

   p10: `Você tem alterações não salvas. Deseja descartá-las e trocar de pergunta?`,

   p11: `Pergunta:`,
   p12: `Inclua uma imagem na sua resposta`,
   p13: `Enviar imagem`,
   p14: `Excluir imagem`,
   p15: `Salvar resposta`,
   p16: `Resposta salva com sucesso`,
   p17: `Ocorreu um erro ao salvar a resposta.`,

   p18: `Ocorreu um erro ao tentar excluir a imagem.`,
   p19: `Escreva sua resposta...`,

   p20: `Bloco de resposta`,
   p21: `Prévia`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}